import { GetOauth2IntegrationForChannel } from '@/connection/integrations/oauth';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const fetchOauthIntegrationReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const oauthIntegration = await GetOauth2IntegrationForChannel(channel);
        return oauthIntegration;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.oauthIntegration = action.payload || null;
      },
    }
  );
};

export default fetchOauthIntegrationReducer;
